module.exports = __webpack_public_path__ + "static/heart-red-0da8ec2919e00b3ecec318ca86a6ccdb.png";